import VueRouter from 'vue-router'
// Pages
import Home from '../components/Home.vue'
import Register from '../components/Register'
import Login from '../components/Login'
import Users from '../components/user/Users.vue'
import Dashboard from '../components/Dashboard.vue';
import PageNotFound from '../components/PageNotFound';
import Roles from '../components/user/Roles';
import Companies from '../components/companies/company';
import WheatTypes from '../components/operations/wheattypes';
import WheatReceive from '../components/operations/wheatreceive';
import WheatIssue from '../components/operations/wheatissue';
import MoveToSilo from '../components/operations/movetosilo';
import IssueFromSilo from '../components/operations/issuefromsilo';
import FlourTypes from '../components/operations/flourtypes';
import FlourWeights from '../components/operations/flourweights';
import ManageFlourTypes from '../components/operations/manageflourtypes';
import Production from '../components/operations/production';
import Contractor from '../components/client-management/contractor';
import Client from '../components/client-management/client';
import Depo from '../components/client-management/depo';
import Shipments from '../components/operations/shipment-govt';
import ShipmentsPrivate from '../components/operations/shipment-private';
import Invoice from '../components/operations/invoice';
import StockTake from '../components/stock-take/stocktake';
import CurrentStatus from '../components/current-status/current-status';
import DbBackup from '../components/db-backup/db-backup';
import ProductionReport from '../components/reports/production-report';
import ShipmentReport from '../components/reports/shipment-report';
import ShipmentReportGov from '../components/reports/shipment-report-gov.vue'
import ShipmentReportPrivate from '../components/reports/shipment-report-private.vue'
import ProductionGraph from '../components/reports/production-graph';
import ProductionWheatSacksGraph from '../components/reports/production-wheatsacks-graph.vue'
import ProductionBranPercentageGraph from '../components/reports/production-bran-percentage-graph.vue'
import ProductionDetailGraph from '../components/reports/production-detail-graph';
import ShipmentGraph from '../components/reports/shipment-graph';
import ShipmentDetailGraph from '../components/reports/shipment-detail-graph';
import ShipmentBilling from '../components/shipment-billing/shipment-billing';
import UnitRate from '../components/shipment-billing/unit-rates';
import DeletedUsers from '../components/user/deleted-users';

// Routes
const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    // redirect: {name: 'login'},
    meta: {
      auth: true
    }
  },
  {
    path:'/dbbackup',
    name:'dbbackup',
    component:DbBackup,
    meta:{
      auth:true
    }
  },
  {
    path:'/generate invoice',
    name:'generateinvoice',
    component:ShipmentBilling,
    meta:{
      auth:true
    }
  },
  {
    path:'/unit rates',
    name:'unitrate',
    component:UnitRate,
    meta:{
      auth:true
    }
  },
  {
    path:'/production report',
    name:'productionreport',
    component:ProductionReport,
    meta:{
      auth:true
    }
  },
  {
    path:'/production graph',
    name:'productiongraph',
    component:ProductionGraph,
    meta:{
      auth:true
    }
  },
  {
    path:'/Wheat Grinding Graph',
    name:'productionWheatSacksGraph',
    component:ProductionWheatSacksGraph,
    meta:{
      auth:true
    }
  },
  {
    path:'/Bran Percentage Graph',
    name:'productionBranPercentageGraph',
    component:ProductionBranPercentageGraph,
    meta:{
      auth:true
    }
  },
  {
    path:'/shipment graph',
    name:'shipmentgraph',
    component:ShipmentGraph,
    meta:{
      auth:true
    }
  },
  {
    path:'/shipment detail graph',
    name:'shipmentdetailgraph',
    component:ShipmentDetailGraph,
    meta:{
      auth:true
    }
  },
  {
    path:'/production detail graph',
    name:'productiondetailgraph',
    component:ProductionDetailGraph,
    meta:{
      auth:true
    }
  },
  {
    path:'/shipment report',
    name:'shipmentreport',
    component:ShipmentReport,
    meta:{
      auth:true
    }
  },
  {
    path:'/Gov Shipment Report',
    name:'ShipmentReportGov',
    component:ShipmentReportGov,
    meta:{
      auth:true
    }
  },
  {
    path:'/Private Shipment Report',
    name:'ShipmentReportPrivate',
    component:ShipmentReportPrivate,
    meta:{
      auth:true
    }
  },
  {
    path:'/verify stock',
    name:'stocktake',
    component:StockTake,
    meta:{
      auth:true
    }
  },
  {
    path:'/role',
    name:'role',
    component:Roles,
    meta:{
      auth:true
    }
  },
  {
    path:'/current status',
    name:'currentstatus',
    component:CurrentStatus,
    meta:{
      auth:true
    }
  },
  {
    path:'/invoice',
    name:'invoice',
    component:Invoice,
    meta:{
      auth:true
    }
  },
  
  {
    path:'/shipmentother',
    name:'shipmentother',
    component:ShipmentsPrivate,
    meta:{
      auth:true
    }
  },
  {
    path:'/Shipmentgovt',
    name:'shipmentgovt',
    component:Shipments,
    meta:{
      auth:true
    }
  },
  {
    path:'/wheat type',
    name:'wheattypes',
    component:WheatTypes,
    meta:{
      auth:true
    }
  },
  {
    path:'/flour type',
    name:'flourtype',
    component:FlourTypes,
    meta:{
      auth:true
    }
  },
  {
    path:'/contractor',
    name:'contractor',
    component:Contractor,
    meta:{
      auth:true
    }
  },
  {
    path:'/depot',
    name:'depot',
    component:Depo,
    meta:{
      auth:true
    }
  },
  {
    path:'/client',
    name:'client',
    component:Client,
    meta:{
      auth:true
    }
  },
  {
    path:'/flour weight',
    name:'flourweight',
    component:FlourWeights,
    meta:{
      auth:true
    }
  },
  {
    path:'/production',
    name:'production',
    component:Production,
    meta:{
      auth:true
    }
  },
  {
    path:'/manage flour types',
    name:'manageflourtypes',
    component:ManageFlourTypes,
    meta:{
      auth:true
    }
  },
  {
    path:'/wheat receive',
    name:'wheatreceive',
    component:WheatReceive,
    meta:{
      auth:true
    }
  },
  {
    path:'/wheat issue',
    name:'wheatissue',
    component:WheatIssue,
    meta:{
      auth:true
    }
  },
  {
    path:'/move stock to silo',
    name:'movetosilo',
    component:MoveToSilo,
    meta:{
      auth:true
    }
  },
  {
    path:'/wheat issue from silo',
    name:'issuefromsilo',
    component:IssueFromSilo,
    meta:{
      auth:true
    }
  },
  {
    path:'/companies list',
    name:'companies list',
    component:Companies,
    meta: {
      auth: {roles: ['superadmin'], redirect: {name: 'login'}, forbiddenRedirect: '/403'}
    }
  },

  {
    path: '/user',
    name: 'users',
    component: Users,
    meta: {
      auth: true
    }
  },
  {
    path:'/deleted users',
    name:'deletedusers',
    component:DeletedUsers,
    meta:{
      auth:true
    }
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    meta: {
      auth: false
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      auth: false
    }
  },

  
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      auth: {roles: ["Admin","Manager"], forbiddenRedirect: '/403'}
    }
  },

  // ADMIN ROUTES
  // {
  //   path: '/admin',
  //   name: 'admin.dashboard',
  //   component: AdminDashboard,
  //   meta: {
  //     auth: {roles: [1], redirect: {name: 'login'}, forbiddenRedirect: '/403'}
  //   }
  // },
  {path:'/404',name:'PageNotFound',component:PageNotFound},
  { path:"*", name: 'redirectPageNotFound', redirect: '/404' }
]
const router = new VueRouter({
  history: true,
  mode:'hash',
  routes:routes
})
export default router